import { Form } from 'factorial-form'

class ProjectionForm extends Form {
  constructor(values: {
    id?: string | null
    path?: string
    function?: string
    order?: string
    group?: string
    ui_group?: string
  }) {
    super(values, {
      id: 'string',
      path: 'string',
      function: 'string',
      order: 'string',
      group: 'string',
      ui_group: 'string',
    })
  }

  get isCompleted(): boolean {
    return this.isComplete
  }
}

export default ProjectionForm
